import LogisticsForm from './logistics-form';

export default LogisticsForm;
